export class EmbroideryThreadReq {
    id?: number
    productCode?: string;
    color?: string;
    shadeNumber?: string;
    tex?: string;
    consumption?: number;
    mtrsPerCone?: string;

    constructor(
        id?: number,
        productCode?: string,
        color?: string,
        shadeNumber?: string,
        tex?: string,
        consumption?: number,
        mtrsPerCone?: string,
    ) {
        this.id=id
        this.productCode = productCode
        this.color = color
        this.shadeNumber = shadeNumber
        this.tex = tex
        this.consumption = consumption
        this.mtrsPerCone = mtrsPerCone
    }
}